
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/migration/troubleshooting",
      function () {
        return require("private-next-pages/material-ui/migration/troubleshooting.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/migration/troubleshooting"])
      });
    }
  